import React, { useState, useEffect } from 'react';
import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  TextField,
  Button,
  FormGroup,
  useTheme,
  DialogActions,
  DialogContentText,
  Slider,
  Typography,
  useMediaQuery,
  Switch,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup as MuiFormGroup,
  Autocomplete,
  Paper,

  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { collection, getDocs, where, query } from 'firebase/firestore';

import {db} from '../../firebaseConfig';

import { useUser } from "../../common/UserContext";

import { useApplicationMode } from "../../common/ApplicationModeContext";

const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = (value) => {
  const result = value.replace(/[^0-9]/g, '');
  if (result.length === 0) return '';
  return `$${Number(result).toLocaleString()}`;
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};

const formatDecimal = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `${result}` : '';

    } else 
    {
      return "";
    }
};


const formatInteger = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9]/g, '');
      
        result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        
        return result ? `${result}` : '';

    } else 
    {
      return "";
    }
};

const NewBeneficiaryModal = ({ isOpen, onClose, onSave, beneficiary }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [maximized, setMaximized] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const { appUserAccountNumber } = useUser();

  const { applicationMode } = useApplicationMode(); 
  
  const [firstName, setFirstName] = useState('');
const [lastName, setLastName] = useState('');
const [associatedCauseId, setAssociatedCauseId] = useState('');
const [associatedCauses, setAssociatedCauses] = useState([]);
const [dateOfBirth, setDateOfBirth] = useState('');
const [gender, setGender] = useState('');
const [contactInfo, setContactInfo] = useState('');
const [uniqueNeeds, setUniqueNeeds] = useState([]);
const [newUniqueNeeds, setNewUniqueNeeds] = useState('');
const [associatedEventId, setAssociatedEventId] = useState('');
const [associatedEvents, setAssociatedEvents] = useState([]);
const [associatedDonationIds, setAssociatedDonationIds] = useState([]);
const [selectedAssociatedDonationIds, setSelectedAssociatedDonationIds] = useState([]);
const [photo, setPhoto] = useState(null);
const [photoFileName, setPhotoFileName] = useState('');
const [successStories, setSuccessStories] = useState([]);
const [newSuccessStories, setNewSuccessStories] = useState('');
const [monthlySupportAmount, setMonthlySupportAmount] = useState('');
const [acknowledgementReceived, setAcknowledgementReceived] = useState('');


  const [validationErrors, setValidationErrors] = useState({});
  const [fontSize, setFontSize] = useState(14);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);

  const CustomPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[700] : colors.greenAccent[700],
  }));

  // Add state for password visibility
  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (isOpen) {
      if (beneficiary) {
        setFirstName(beneficiary.firstName);
setLastName(beneficiary.lastName);
setAssociatedCauseId(beneficiary.associatedCauseId || '');
setDateOfBirth(beneficiary.dateOfBirth?new Date(beneficiary.dateOfBirth.seconds * 1000).toISOString().slice(0, 10):'');
setGender(beneficiary.gender);
setContactInfo(beneficiary.contactInfo);
setUniqueNeeds(beneficiary.uniqueNeeds || []);setAssociatedEventId(beneficiary.associatedEventId || '');
setSelectedAssociatedDonationIds(beneficiary.associatedDonationIds  || []);
setPhoto(beneficiary.photo || null);setPhotoFileName(beneficiary.photoFileName);
setSuccessStories(beneficiary.successStories || []);setMonthlySupportAmount(formatCurrency(beneficiary.monthlySupportAmount.toString()));
setAcknowledgementReceived(beneficiary.acknowledgementReceived);

       
      } else {
        setFirstName('');
setLastName('');
setAssociatedCauseId('');
setDateOfBirth('');
setGender('');
setContactInfo('');
setUniqueNeeds([]);
setAssociatedEventId('');
setSelectedAssociatedDonationIds([]);
setPhoto(null);
setPhotoFileName('');
setSuccessStories([]);
setMonthlySupportAmount(0);
setAcknowledgementReceived(false);

      }
      setValidationErrors({});
    }
  }, [isOpen, beneficiary]);

  
                useEffect(() => {
                    const fetchAssociatedCauses = async () => {
                      const associatedCausesCollection = collection(db, 'charitableCauses');
                      const q = query(associatedCausesCollection, where("appAccountNumber", "==", appUserAccountNumber), where("applicationMode", "==", applicationMode));
                      const associatedCausesSnapshot = await getDocs(q);
                      const associatedCausesData = associatedCausesSnapshot.docs.map(doc => ({
                        id: doc.id,
                        name: doc.data().title
                      }));
                      setAssociatedCauses(associatedCausesData);
                    };
                
                    fetchAssociatedCauses();
                  }, [appUserAccountNumber, applicationMode]);
                
                


                useEffect(() => {
                    const fetchAssociatedEvents = async () => {
                      const associatedEventsCollection = collection(db, 'events');
                      const q = query(associatedEventsCollection, where("appAccountNumber", "==", appUserAccountNumber), where("applicationMode", "==", applicationMode));
                      const associatedEventsSnapshot = await getDocs(q);
                      const associatedEventsData = associatedEventsSnapshot.docs.map(doc => ({
                        id: doc.id,
                        name: doc.data().title
                      }));
                      setAssociatedEvents(associatedEventsData);
                    };
                
                    fetchAssociatedEvents();
                  }, [appUserAccountNumber, applicationMode]);
                
                


                    useEffect(() => {
                        const fetchAssociatedDonationIds = async () => {
                          const associatedDonationIdsCollection = collection(db, 'donations');
                          const q = query(associatedDonationIdsCollection, where("appAccountNumber", "==", appUserAccountNumber), where("applicationMode", "==", applicationMode));
                          const associatedDonationIdsSnapshot = await getDocs(q);
                          const associatedDonationIdsData = associatedDonationIdsSnapshot.docs.map(doc => ({
                            id: doc.id,
                            name: doc.data().amount
                          }));
                          setAssociatedDonationIds(associatedDonationIdsData);
                        };
                    
                        fetchAssociatedDonationIds();
                      }, [appUserAccountNumber, applicationMode]);
                    
                    



  const increaseFontSize = () => {
    if (fontSize < 21) {
      setFontSize(fontSize + 1);
    }
  };

  const decreaseFontSize = () => {
    if (fontSize > 11) {
      setFontSize(fontSize - 1);
    }
  };

  const handleFieldChange = (setter, formatter) => (event) => {
    if (formatter != null) {
      setter(formatter(event.target.value));
    } else {
      setter(event.target.value);
    }
    setValidationErrors((prev) => ({ ...prev, [event.target.id]: false }));
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
    onClose();
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
  };

  ;
      
      
  const handleSave = () => {
    const errors = {};

    if (!firstName) errors.firstName = true;
if (!lastName) errors.lastName = true;
if (!associatedCauseId) errors.associatedCauseId = true;


    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setErrorDialogOpen(true);
      return;
    }

    const beneficiaryEntry = {
      firstName,
lastName,
associatedCauseId,
dateOfBirth:convertDateToFirestoreTimestamp(dateOfBirth),
gender,
contactInfo,
uniqueNeeds,
associatedEventId,
associatedDonationIds:selectedAssociatedDonationIds,
photo,
photoFileName,
successStories,
monthlySupportAmount:monthlySupportAmount? parseFloat(monthlySupportAmount.replace(/[^0-9.]/g, '')) : 0,
acknowledgementReceived,
appAccountNumber:appUserAccountNumber,
applicationMode:applicationMode
    };

    if (beneficiary != null && beneficiary.id != null) {
      beneficiaryEntry.id = beneficiary.id;
    }

    onSave(beneficiaryEntry);
    onClose();
  };

   
                      const handleAddUniqueNeeds = () => {
                            if (newUniqueNeeds.trim() !== '') {
                            setUniqueNeeds([...uniqueNeeds, newUniqueNeeds.trim()]);
                            setNewUniqueNeeds('');
                            }
                        };

                        const handleRemoveUniqueNeeds = (index) => {
                            const updatedUniqueNeeds = [...uniqueNeeds];
                            updatedUniqueNeeds.splice(index, 1);
                            setUniqueNeeds(updatedUniqueNeeds);
                        };
    
                    
 const handleAssociatedDonationIdsChange = (id) => {
                    setSelectedAssociatedDonationIds(prevState => {
                    if (prevState.includes(id)) {
                        return prevState.filter(associatedDonationIdsId => associatedDonationIdsId !== id);
                    } else {
                        return [...prevState, id];
                    }
                    });
                };
                
 const handlePhotoFileChange = (event) => {
                    const file = event.target.files[0];
                    if (file) {
                    const reader = new FileReader();
                    reader.onload = () => {

                      let existingFilesTotalSize = getExistingFileTotalSize();
                      const nextTotalSize = existingFilesTotalSize + reader.result.length;

                      if (nextTotalSize < 1048487)
                      {
                        setPhoto(reader.result);
                        setPhotoFileName(file.name);
                      } else
                      {
                        alert("The "+file.name+" file cannot be added because it would cause the total attached file size for the record to exceed the maximum allowed size of 1,048,576 bytes");
                      }
                    };
                    reader.readAsDataURL(file);
                    }

                    // Clear the input
                    event.target.value = '';
                };

                   const handleRemovePhotoImage = () => {
                    setPhoto(null);
                    setPhotoFileName(null);
                };

                
 
                      const handleAddSuccessStories = () => {
                            if (newSuccessStories.trim() !== '') {
                            setSuccessStories([...successStories, newSuccessStories.trim()]);
                            setNewSuccessStories('');
                            }
                        };

                        const handleRemoveSuccessStories = (index) => {
                            const updatedSuccessStories = [...successStories];
                            updatedSuccessStories.splice(index, 1);
                            setSuccessStories(updatedSuccessStories);
                        };
    
                    


  
     const getExistingFileTotalSize = () => {

       let existingFilesTotalSize = 0;

    


             if (photo != null)
             {
               existingFilesTotalSize += photo.length;
             }

            

    
      return existingFilesTotalSize;
    }

   

  
  const stringToColorLight = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always light by adding a base value of 127
      const lightValue = ((value + 127) % 128) + 127;
      color += ('00' + lightValue.toString(16)).substr(-2);
    }
    return color;
  };
  
  const stringToColorDark = (str) => {
  
    return stringToColorLight(str); // We will use the same colors
  };
  
  const stringToColorDarkOLD = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always dark by restricting them to the first half of 256
      const darkValue = value % 128;
      color += ('00' + darkValue.toString(16)).substr(-2);
    }
    return color;
  };
  

  
  const convertDateToFirestoreTimestamp = (dateString) => {

    if (dateString !== "" && dateString != null)
    {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          throw new Error("Invalid date format. Please use mm/dd/yyyy format.");
        }
        const seconds = Math.floor(date.getTime() / 1000);
        const nanoseconds = 0;
        return {
          seconds: seconds,
          nanoseconds: nanoseconds
        };
    } else 
    {
      return null;
    }
  };

  const convertTimeStringToFirestoreTimestamp = (timeString) => {

    if (timeString !== "" && timeString != null)
    {
        // Get the current date
        const now = new Date();
      
        // Extract hours and minutes from the time string
        const [hours, minutes] = timeString.split(':').map(Number);
      
        // Validate the time string
        if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
          throw new Error("Invalid time format. Please use HH:mm format.");
        }
      
        // Set the hours and minutes on the current date
        now.setHours(hours);
        now.setMinutes(minutes);
        now.setSeconds(0);
        now.setMilliseconds(0);
      
        // Convert the Date object to seconds since Unix epoch
        const seconds = Math.floor(now.getTime() / 1000);
        const nanoseconds = 0;
      
        // Return the Firestore-like timestamp object
        return {
          seconds: seconds,
          nanoseconds: nanoseconds
        };
    } else 
    {
      return null;
    }
  };
  
  const convertFirestoreTimestampToTimeString = (timestamp) => {

    if (timestamp != null && timestamp !=="")
    {
        // Convert the seconds since Unix epoch to a Date object
        const date = new Date(timestamp.seconds * 1000);
      
        // Extract hours and minutes
        const hours = date.getHours();
        const minutes = date.getMinutes();
      
        // Format hours and minutes as a time string in "HH:mm" format
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
      
        return `${formattedHours}:${formattedMinutes}`;
    } else 
    {
      return "";
    }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  const renderFileSize = (base64String) => {

    if (base64String != null)
    {
      const sizeInBytes = base64String.length * (3 / 4) - (base64String.indexOf('=') > 0 ? base64String.split('=').length - 1 : 0);
      const sizeInKB = sizeInBytes / 1024;
      const sizeInMB = sizeInKB / 1024;
    
      if (sizeInMB >= 1) {
        return <div style={{textAlign:'center'}}>{sizeInMB.toFixed(2)} MB</div>//`${sizeInMB.toFixed(2)} MB`;
      } else {
        return <div style={{textAlign:'center'}}>{sizeInKB.toFixed(2)} KB</div> //`${sizeInKB.toFixed(2)} KB`;
      }
    } else
    {
      return <div></div>;
    }
  };
  
  const renderThumbnail = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '100px', maxHeight: '100px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
  
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setConfirmOpen(true)}
        fullScreen={maximized}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: colors.inputModal.dialogHeaderBackgroundColor }}>
        <Box sx={{ color: (theme) => theme.palette.grey[100] }}>
            {beneficiary ? "Edit Beneficiary : " +beneficiary.id : "Add New Beneficiary"}
          </Box>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton aria-label="decrease font size" onClick={decreaseFontSize} sx={{ marginRight: 1, color: (theme) => theme.palette.grey[500] }}>
              <RemoveIcon />
            </IconButton>
            <IconButton aria-label="increase font size" onClick={increaseFontSize} sx={{ color: (theme) => theme.palette.grey[500] }}>
              <AddIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              aria-label={maximized ? "exit full screen" : "full screen"}
              onClick={() => setMaximized(!maximized)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              {maximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
            <IconButton
              aria-label="close"
              onClick={() => setConfirmOpen(true)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ backgroundColor: colors.inputModal.dialogContentBackgroundColor }}>
          <FormGroup>
            <Grid container spacing={2}>
            
            <Grid item xs={12} md={6}>

<TextField fullWidth margin="normal" id="firstName" label="First Name"  value={firstName} onChange={handleFieldChange(setFirstName)} error={validationErrors.firstName}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="lastName" label="Last Name"  value={lastName} onChange={handleFieldChange(setLastName)} error={validationErrors.lastName}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<Autocomplete
                fullWidth
                margin="normal" 
                options={associatedCauses}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label="Causes"   error={validationErrors.associatedCauseId}  margin="normal" inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={associatedCauses.find(ref => ref.id === associatedCauseId) || null}
                onChange={(event, newValue) => setAssociatedCauseId(newValue ? newValue.id : '')}
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
</Grid>

<Grid item xs={12} md={6}>


                <TextField
                fullWidth
                margin="normal"
                id="dateOfBirth"
                label="Date of Birth"
                type="date" 
                InputLabelProps={{ shrink: true, style: { fontSize } }}
                value={dateOfBirth}
                onChange={e => setDateOfBirth(e.target.value)} 
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.inputModal.inputBackgroundColor, 
                    '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                      borderColor: colors.inputModal.inputHoverBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.inputModal.inputFocusedBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                      color: colors.inputModal.inputHoverBorderColor,
                    },
                    '&.Mui-focused': {
                      color: 'currentColor',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                  },
                  '& input::-webkit-calendar-picker-indicator': {
                    filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                  },
                }}
             />
                

                <Autocomplete
                fullWidth
                margin="normal"
                options={[
                  "Male","Female","Other"
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="Gender" margin="normal"   inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={gender}
                onChange={(event, newValue) => setGender(newValue)} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
                
<Autocomplete
                fullWidth
                margin="normal" 
                options={associatedEvents}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label="Events"   margin="normal" inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={associatedEvents.find(ref => ref.id === associatedEventId) || null}
                onChange={(event, newValue) => setAssociatedEventId(newValue ? newValue.id : '')}
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
<TextField fullWidth margin="normal" id="monthlySupportAmount" label="Monthly Support Amount"  value={monthlySupportAmount} onChange={handleFieldChange(setMonthlySupportAmount, formatCurrency)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>


                    
                    <Slider
                        value={parseFloat(monthlySupportAmount.toString().replace(/[^0-9.]/g, '')) || 0}
                        onChange={(e, newValue) => setMonthlySupportAmount(formatCurrency(newValue.toString()))}
                        min={0}
                        max={1000}
                        step={50}
                        valueLabelDisplay="auto"
                        sx={{ marginY: 1, marginLeft:'5px', paddingTop :'0px',marginTop :'0px',color: colors.inputModal.inputDefaultBorderColor }}
                        />
                    
                        

                    </Grid>


            
            </Grid>
              
            
                <TextField
                fullWidth
                margin="normal"
                id="contactInfo" 
                error={validationErrors.contactInfo} 
                label="Contact Information"
                multiline
                rows={4}
                value={contactInfo}
                onChange={handleFieldChange(setContactInfo)}
                inputProps={{ style: { fontSize } }} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
                />
                    

    
                        <FormControl component="fieldset" margin="normal">
                            <FormLabel component="legend">Unique Needs</FormLabel>
                            <Grid container spacing={2}>
                                <Grid item xs={isMobile?9:3}>
                                <TextField
                                    fullWidth
                                    id="newUniqueNeeds"
                                    label="Add UniqueNeeds"
                                    value={newUniqueNeeds}
                                    onChange={(e) => setNewUniqueNeeds(e.target.value)}
                                    onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleAddUniqueNeeds();
                                    }
                                    }}
                                    sx={{'& .MuiOutlinedInput-root': {
                                            backgroundColor: colors.inputModal.inputBackgroundColor,
                                        '& fieldset': {
                                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                                        '&:hover fieldset': {
                                            borderColor: colors.inputModal.inputHoverBorderColor,
                                            ...(theme.palette.mode !== 'dark' && {
                                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                                            }),
                                            },
                                        '&.Mui-focused fieldset': {
                                            borderColor: colors.inputModal.inputFocusedBorderColor,
                                            ...(theme.palette.mode !== 'dark' && {
                                                boxShadow: '0 0 3px 1px blue',
                                            }),
                                            },},
                                        '& .MuiInputLabel-root': {
                                            color:colors.inputModal.inputDefaultBorderColor, 
                                        '&:hover': {
                                            color: colors.inputModal.inputHoverBorderColor,},
                                        '&.Mui-focused': {
                                            color: 'currentColor',},},}}
                                />
                                </Grid>
                                <Grid item xs={2}>
                                <Button variant="contained" onClick={handleAddUniqueNeeds} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] }, height: '98%',fontSize:'30px',margin:'0px',padding:'0px' }}>
                                    +
                                </Button>
                                </Grid>
                            </Grid>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                                {uniqueNeeds.map((uniqueNeed, index) => (
                                <div key={index} style={{ backgroundColor: colorFunction(uniqueNeed), padding: '5px 10px', borderRadius: '13px', position: 'relative', color: theme.palette.mode === "dark" ? '#000000' : '#000000' }}>
                                    {uniqueNeed} &nbsp;&nbsp;&nbsp;&nbsp;
                                    <IconButton
                                    size="small"
                                    style={{ position: 'absolute', top: 0, right: 0, color: 'red' }}
                                    onClick={() => handleRemoveUniqueNeeds(index)}
                                    >
                                    <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </div>
                                ))}
                            </div>
                            </FormControl>
                            

                        <FormControl component="fieldset" margin="normal">
                            <FormLabel component="legend">Donations</FormLabel>
                            <MuiFormGroup row>
                            {associatedDonationIds.map(item => (
                                <FormControlLabel
                                key={item.id}
                                control={
                                    <Checkbox
                                    checked={selectedAssociatedDonationIds.includes(item.id)}
                                    onChange={() => handleAssociatedDonationIdsChange(item.id)}
                                    sx={{
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        '&.Mui-checked': {
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        },
                                    }}
                                    />
                                }
                                label={item.name}
                                />
                            ))}
                            </MuiFormGroup>
                        </FormControl>
                            
                    

                        <FormControl component="fieldset" margin="normal">
              <FormLabel component="legend">Photo</FormLabel>
              <input type="file" accept=".*" onChange={handlePhotoFileChange} />

              <div style={{ maxWidth:'100px', width:'100px', position: 'relative'}}> 
              <div>{photoFileName}</div>
              {renderThumbnail(photo,photoFileName)}

              {renderFileSize(photo)}

              {photo && ( 
              <IconButton
                    size="small"
                    style={{ position: 'absolute', top: 20, right: 5, color: 'red' }}
                    onClick={() => handleRemovePhotoImage()}
                    >
                    <DeleteIcon />
                    </IconButton>
               )}
              </div>
            </FormControl>
                        

    
                        <FormControl component="fieldset" margin="normal">
                            <FormLabel component="legend">Success Stories</FormLabel>
                            <Grid container spacing={2}>
                                <Grid item xs={isMobile?9:3}>
                                <TextField
                                    fullWidth
                                    id="newSuccessStories"
                                    label="Add SuccessStories"
                                    value={newSuccessStories}
                                    onChange={(e) => setNewSuccessStories(e.target.value)}
                                    onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleAddSuccessStories();
                                    }
                                    }}
                                    sx={{'& .MuiOutlinedInput-root': {
                                            backgroundColor: colors.inputModal.inputBackgroundColor,
                                        '& fieldset': {
                                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                                        '&:hover fieldset': {
                                            borderColor: colors.inputModal.inputHoverBorderColor,
                                            ...(theme.palette.mode !== 'dark' && {
                                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                                            }),
                                            },
                                        '&.Mui-focused fieldset': {
                                            borderColor: colors.inputModal.inputFocusedBorderColor,
                                            ...(theme.palette.mode !== 'dark' && {
                                                boxShadow: '0 0 3px 1px blue',
                                            }),
                                            },},
                                        '& .MuiInputLabel-root': {
                                            color:colors.inputModal.inputDefaultBorderColor, 
                                        '&:hover': {
                                            color: colors.inputModal.inputHoverBorderColor,},
                                        '&.Mui-focused': {
                                            color: 'currentColor',},},}}
                                />
                                </Grid>
                                <Grid item xs={2}>
                                <Button variant="contained" onClick={handleAddSuccessStories} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] }, height: '98%',fontSize:'30px',margin:'0px',padding:'0px' }}>
                                    +
                                </Button>
                                </Grid>
                            </Grid>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                                {successStories.map((successStory, index) => (
                                <div key={index} style={{ backgroundColor: colorFunction(successStory), padding: '5px 10px', borderRadius: '13px', position: 'relative', color: theme.palette.mode === "dark" ? '#000000' : '#000000' }}>
                                    {successStory} &nbsp;&nbsp;&nbsp;&nbsp;
                                    <IconButton
                                    size="small"
                                    style={{ position: 'absolute', top: 0, right: 0, color: 'red' }}
                                    onClick={() => handleRemoveSuccessStories(index)}
                                    >
                                    <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </div>
                                ))}
                            </div>
                            </FormControl>
                            

                <FormControlLabel
                    control={<Switch checked={acknowledgementReceived} onChange={(e) => setAcknowledgementReceived(e.target.checked)} 
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        '&:hover': {
                            backgroundColor: 'rgba(0, 128, 0, 0.1)',
                        },
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        },
                    }}
                    />}
                    label="Acknowledgment Received"
                    />
                


          </FormGroup>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" onClick={handleSave} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>Save</Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={confirmOpen}
        onClose={handleCancelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Sure you want to close without saving changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Validation Error"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Please fill all required fields.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={() => setErrorDialogOpen(false)} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewBeneficiaryModal;
